import React from 'react';

export const ContentLayout = ({ children }) => {
  return (
    <div className="w-screen h-full px-4 py-3 overflow:hidden">
      <div className="h-full flex flex-col p-2 bg-white">{children}</div>
    </div>
  );
};
